import { Component, Input} from '@angular/core';
import { StylingService, Theme } from '../services/style-service/styling.service';

declare var $: any;

@Component({
  selector: 'app-sidebar-menu',
  templateUrl: './sidebar-menu.component.html',
  styleUrls: ['./sidebar-menu.component.scss'],
  standalone:false
})
export class SidebarMenuComponent {

  @Input() toggleSub$: any;

  constructor(public stylingService: StylingService) {

  }

  ngOnInit() {
    this.toggleSub$.subscribe(() => {
      this.toggle();
    });
  }

  toggle() {
    $('.ui.sidebar').sidebar('toggle');
  }

  public get theme(): typeof Theme {
    return Theme;
  }

  onColorSelect(event: any, index: number) {
    this.stylingService.colorArr[index] = event.target.value;
    document.documentElement.style.setProperty((index > 0)? '--secondvalue': '--firstvalue', this.stylingService.colorArr[index]);
    this.save();
  }

  selectStyle(style: Theme) {
    this.stylingService.theme = style;

    switch (this.stylingService.theme) {
      case Theme.webBrightTheme: {
        document.documentElement.style.setProperty('--bodyBg', "white");
        document.documentElement.style.setProperty('--fontColor', "black");
        break;
      }
      case Theme.webDarkTheme: {
        document.documentElement.style.setProperty('--bodyBg', "black");
        document.documentElement.style.setProperty('--fontColor', "white");
        break;
      }
      case Theme.desktopBrightTheme:{
        document.documentElement.style.setProperty('--bodyBg', "#f5f7fb");
        document.documentElement.style.setProperty('--fontColor', "black");
        break;
      }
      case Theme.desktopDarkTheme:{
        document.documentElement.style.setProperty('--bodyBg', "#111727");
        document.documentElement.style.setProperty('--fontColor', "white");
        break;
      }
    }

    this.save();
    // this.toggle();
  }

  save() {

  }
}
